/**
 * @generated SignedSource<<93604866a1a1c14403b3cd085998a5f7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CANT_DELETE_TASK_REASON = "HAS_LOCKED_TIME" | "HAS_INVOICED_TIME" | "HAS_TIME_REGS" | "HAS_OTHER_PEOPLES_TIME_REGS" | "JIRA" | "GITHUB" | "UNIT4" | "NO_USER_TYPE" | "BLOCKED_BY_SUBTASK" | "%future added value";
export type DEPENDENCY_TYPE = "CANNOT_START" | "CANNOT_BE_COMPLETED" | "%future added value";
export type PROGRAM_BUDGET_TYPE = "UNCAPPED" | "CAPPED" | "FIXED_PRICE" | "%future added value";
export type PROJECT_STATUS = "OPPORTUNITY" | "PLANNING" | "RUNNING" | "HALTED" | "DONE" | "%future added value";
export type STATUS_CATEGORY = "TODO" | "INPROGRESS" | "DONE" | "%future added value";
export type UpdateTaskInput = {
  ids?: ReadonlyArray<string | null> | null;
  projectId?: string | null;
  projectGroupId?: string | null;
  parentId?: string | null;
  phaseId?: string | null;
  aboveTaskId?: string | null;
  aboveFavouredTaskId?: string | null;
  name?: string | null;
  description?: string | null;
  estimateLow?: number | null;
  estimateHigh?: number | null;
  forecast?: number | null;
  timeLeft?: number | null;
  startYear?: number | null;
  startMonth?: number | null;
  startDay?: number | null;
  deadlineYear?: number | null;
  deadlineMonth?: number | null;
  deadlineDay?: number | null;
  roleId?: string | null;
  assignedPersons?: ReadonlyArray<string | null> | null;
  unassignAllPersons?: boolean | null;
  assignedPersonToAdd?: string | null;
  followers?: ReadonlyArray<string | null> | null;
  removeAllFollowers?: boolean | null;
  labels?: ReadonlyArray<string | null> | null;
  clearAllLabels?: boolean | null;
  sprintId?: string | null;
  projectGroupSprintId?: string | null;
  statusColumnId?: string | null;
  statusColumnV2Id?: string | null;
  projectGroupStatusColumnId?: number | null;
  coverFileId?: string | null;
  blocked?: boolean | null;
  bug?: boolean | null;
  approved?: boolean | null;
  billable?: boolean | null;
  repeatingTaskId?: string | null;
  unassignedTaskId?: string | null;
  previousProjectId?: string | null;
  unassignPersonFromTask?: ReadonlyArray<UnassignPersonFromTask | null> | null;
  remaining?: number | null;
  highPriority?: boolean | null;
  ownerId?: string | null;
  favoured?: boolean | null;
  favouredSortOrder?: string | null;
  parentTaskId?: string | null;
  deliverableId?: string | null;
  previousParentTaskId?: string | null;
  isBulkContext?: boolean | null;
  validateDependencies?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type UnassignPersonFromTask = {
  taskId: string;
  personIds?: ReadonlyArray<string | null> | null;
};
export type moveTaskToAnotherProjectMutation$variables = {
  input: UpdateTaskInput;
};
export type moveTaskToAnotherProjectMutation$data = {
  readonly updateTask: {
    readonly errors: ReadonlyArray<string | null> | null;
    readonly updatedTasksIds: ReadonlyArray<string | null> | null;
    readonly tasks: ReadonlyArray<{
      readonly id: string;
      readonly userCanDeleteTask: boolean | null;
      readonly userCantDeleteTaskReason: CANT_DELETE_TASK_REASON | null;
      readonly fullAccessToProject: boolean | null;
      readonly approved: boolean | null;
      readonly name: string | null;
      readonly readOnly: {
        readonly isReadOnly: boolean | null;
      } | null;
      readonly coverFile: {
        readonly id: string;
      } | null;
      readonly parentTaskId: string | null;
      readonly parentTask: {
        readonly id: string;
        readonly companyTaskId: number | null;
        readonly name: string | null;
        readonly parentTask: {
          readonly id: string;
          readonly companyTaskId: number | null;
          readonly name: string | null;
        } | null;
      } | null;
      readonly hasChildren: boolean | null;
      readonly companyTaskId: number | null;
      readonly blocked: boolean | null;
      readonly bug: boolean | null;
      readonly billable: boolean | null;
      readonly highPriority: boolean | null;
      readonly startYear: number | null;
      readonly startMonth: number | null;
      readonly startDay: number | null;
      readonly description: string | null;
      readonly jiraId: string | null;
      readonly jiraKey: string | null;
      readonly gitlabIid: string | null;
      readonly vstsId: string | null;
      readonly pipedriveId: string | null;
      readonly isUnit4Task: boolean | null;
      readonly estimateForecast: number | null;
      readonly timeLeft: number | null;
      readonly deadlineDay: number | null;
      readonly deadlineMonth: number | null;
      readonly deadlineYear: number | null;
      readonly startFrom: string | null;
      readonly deadlineFrom: string | null;
      readonly gitlabServerIid: string | null;
      readonly hasLockedTime: boolean | null;
      readonly hasInvoicedTime: boolean | null;
      readonly favoured: boolean | null;
      readonly sageIntacctId: string | null;
      readonly progressDetails: {
        readonly progress: number | null;
      } | null;
      readonly followers: ReadonlyArray<{
        readonly id: string;
        readonly firstName: string | null;
        readonly lastName: string | null;
        readonly profilePictureId: string | null;
        readonly profilePictureDefaultId: number | null;
      } | null> | null;
      readonly taskLabels: ReadonlyArray<{
        readonly label: {
          readonly id: string;
          readonly name: string | null;
          readonly color: string | null;
        } | null;
      } | null> | null;
      readonly subTasks: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly estimate: number | null;
            readonly done: boolean | null;
            readonly sortOrder: number | null;
            readonly name: string | null;
            readonly description: string | null;
            readonly startDay: number | null;
            readonly startMonth: number | null;
            readonly startYear: number | null;
            readonly endDay: number | null;
            readonly endMonth: number | null;
            readonly endYear: number | null;
            readonly startFrom: string | null;
            readonly endFrom: string | null;
            readonly role: {
              readonly id: string;
              readonly name: string | null;
            } | null;
            readonly person: {
              readonly id: string;
              readonly firstName: string | null;
              readonly lastName: string | null;
              readonly active: boolean | null;
              readonly profilePictureId: string | null;
              readonly profilePictureDefaultId: number | null;
            } | null;
          } | null;
        } | null> | null;
      } | null;
      readonly thisTaskDependsOn: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly type: DEPENDENCY_TYPE | null;
            readonly completed: boolean | null;
            readonly taskDependsOnThis: {
              readonly id: string;
              readonly name: string | null;
              readonly companyTaskId: number | null;
              readonly startYear: number | null;
              readonly startMonth: number | null;
              readonly startDay: number | null;
              readonly deadlineDay: number | null;
              readonly deadlineMonth: number | null;
              readonly deadlineYear: number | null;
              readonly statusColumnV2: {
                readonly id: string;
                readonly category: STATUS_CATEGORY | null;
              } | null;
            } | null;
            readonly thisDependsOnTask: {
              readonly id: string;
              readonly name: string | null;
              readonly companyTaskId: number | null;
              readonly startYear: number | null;
              readonly startMonth: number | null;
              readonly startDay: number | null;
              readonly deadlineDay: number | null;
              readonly deadlineMonth: number | null;
              readonly deadlineYear: number | null;
              readonly statusColumnV2: {
                readonly id: string;
                readonly category: STATUS_CATEGORY | null;
              } | null;
            } | null;
          } | null;
        } | null> | null;
      } | null;
      readonly dependsOnThisTask: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly type: DEPENDENCY_TYPE | null;
            readonly completed: boolean | null;
            readonly taskDependsOnThis: {
              readonly id: string;
              readonly name: string | null;
              readonly companyTaskId: number | null;
              readonly startYear: number | null;
              readonly startMonth: number | null;
              readonly startDay: number | null;
              readonly deadlineDay: number | null;
              readonly deadlineMonth: number | null;
              readonly deadlineYear: number | null;
              readonly statusColumnV2: {
                readonly id: string;
                readonly category: STATUS_CATEGORY | null;
              } | null;
            } | null;
            readonly thisDependsOnTask: {
              readonly id: string;
              readonly name: string | null;
              readonly companyTaskId: number | null;
              readonly startYear: number | null;
              readonly startMonth: number | null;
              readonly startDay: number | null;
              readonly deadlineDay: number | null;
              readonly deadlineMonth: number | null;
              readonly deadlineYear: number | null;
              readonly statusColumnV2: {
                readonly id: string;
                readonly category: STATUS_CATEGORY | null;
              } | null;
            } | null;
          } | null;
        } | null> | null;
      } | null;
      readonly repeatingTask: {
        readonly id: string;
        readonly repeatType: string | null;
        readonly monday: boolean | null;
        readonly tuesday: boolean | null;
        readonly wednesday: boolean | null;
        readonly thursday: boolean | null;
        readonly friday: boolean | null;
        readonly saturday: boolean | null;
        readonly sunday: boolean | null;
        readonly monthlyDay: number | null;
      } | null;
      readonly statusColumnV2: {
        readonly id: string;
        readonly name: string | null;
        readonly category: STATUS_CATEGORY | null;
        readonly projectGroupStatusColumnId: number | null;
      } | null;
      readonly phase: {
        readonly id: string;
        readonly name: string | null;
        readonly startYear: number | null;
        readonly startMonth: number | null;
        readonly startDay: number | null;
        readonly deadlineDay: number | null;
        readonly deadlineMonth: number | null;
        readonly deadlineYear: number | null;
      } | null;
      readonly sprint: {
        readonly id: string;
        readonly name: string | null;
        readonly startYear: number | null;
        readonly startMonth: number | null;
        readonly startDay: number | null;
        readonly endDay: number | null;
        readonly endMonth: number | null;
        readonly endYear: number | null;
      } | null;
      readonly assignedPersons: ReadonlyArray<{
        readonly id: string;
        readonly firstName: string | null;
        readonly lastName: string | null;
        readonly role: {
          readonly id: string;
          readonly name: string | null;
        } | null;
        readonly profilePictureId: string | null;
        readonly profilePictureDefaultId: number | null;
        readonly email: string | null;
      } | null> | null;
      readonly timeRegistrations: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly invoiced: boolean | null;
            readonly xeroInvoiceId: string | null;
            readonly minutesRegistered: number | null;
            readonly lockedInPeriod: boolean | null;
          } | null;
        } | null> | null;
      } | null;
      readonly role: {
        readonly id: string;
        readonly name: string | null;
      } | null;
      readonly googleDriveFiles: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string | null;
            readonly name: string | null;
            readonly link: string | null;
            readonly thumb: string | null;
          } | null;
        } | null> | null;
      } | null;
      readonly files: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly name: string | null;
            readonly mimeType: string | null;
            readonly key: string | null;
            readonly size: number | null;
            readonly yearCreated: number | null;
            readonly monthCreated: number | null;
            readonly dayCreated: number | null;
            readonly hourCreated: number | null;
            readonly minuteCreated: number | null;
            readonly secondCreated: number | null;
            readonly person: {
              readonly id: string;
              readonly fullName: string | null;
            } | null;
          } | null;
        } | null> | null;
      } | null;
      readonly commentCount: number | null;
      readonly comments: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly comment: string | null;
            readonly year: number | null;
            readonly month: number | null;
            readonly day: number | null;
            readonly hours: number | null;
            readonly minutes: number | null;
            readonly seconds: number | null;
            readonly person: {
              readonly id: string;
              readonly firstName: string | null;
              readonly lastName: string | null;
              readonly fullName: string | null;
              readonly profilePictureId: string | null;
              readonly profilePictureDefaultId: number | null;
            } | null;
          } | null;
        } | null> | null;
      } | null;
      readonly createdAt: string | null;
      readonly createdBy: {
        readonly id: string;
        readonly firstName: string | null;
        readonly lastName: string | null;
      } | null;
      readonly latestUiUpdateAt: string | null;
      readonly latestUiUpdateBy: {
        readonly id: string;
        readonly firstName: string | null;
        readonly lastName: string | null;
      } | null;
      readonly owner: {
        readonly id: string;
        readonly firstName: string | null;
        readonly lastName: string | null;
        readonly fullName: string | null;
        readonly profilePictureId: string | null;
        readonly profilePictureDefaultId: number | null;
        readonly role: {
          readonly id: string;
          readonly name: string | null;
        } | null;
      } | null;
      readonly project: {
        readonly id: string;
        readonly name: string | null;
        readonly useTaskOwner: boolean | null;
        readonly useTaskFollowers: boolean | null;
        readonly useTaskHierarchy: boolean | null;
        readonly projectStartYear: number | null;
        readonly projectStartMonth: number | null;
        readonly projectStartDay: number | null;
        readonly projectEndYear: number | null;
        readonly projectEndMonth: number | null;
        readonly projectEndDay: number | null;
        readonly status: PROJECT_STATUS | null;
        readonly projectColor: string | null;
        readonly isJiraProject: boolean | null;
        readonly jiraSubtaskType: string | null;
        readonly jiraCloudProject: {
          readonly id: string;
        } | null;
        readonly jiraCloudEpicIds: ReadonlyArray<string | null> | null;
        readonly jiraServerProject: {
          readonly id: string;
        } | null;
        readonly gitlabProjectName: string | null;
        readonly gitlabServerProjectName: string | null;
        readonly projectGroupId: string | null;
        readonly billable: boolean | null;
        readonly taskLevels: number | null;
        readonly companyProjectId: number | null;
        readonly customProjectId: string | null;
        readonly isProgramRevenueLocked: boolean | null;
        readonly programBudgetType: PROGRAM_BUDGET_TYPE | null;
        readonly program: {
          readonly name: string | null;
          readonly prefix: string | null;
          readonly budgetType: PROGRAM_BUDGET_TYPE | null;
          readonly members: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly role: string | null;
                readonly person: {
                  readonly id: string;
                } | null;
              } | null;
            } | null> | null;
          } | null;
        } | null;
        readonly harvestProject: {
          readonly id: string;
        } | null;
        readonly manualProgressOnProjectEnabled: boolean | null;
        readonly manualProgressOnPhasesEnabled: boolean | null;
        readonly manualProgressOnTasksEnabled: boolean | null;
        readonly vstsProject: string | null;
        readonly vstsAccount: string | null;
        readonly vstsTwoWaySync: boolean | null;
        readonly sprintTimeBox: boolean | null;
        readonly estimationUnit: string | null;
        readonly remainingAutoCalculated: boolean | null;
        readonly rateCard: {
          readonly id: string;
          readonly disabledRoles: ReadonlyArray<{
            readonly id: string;
          } | null> | null;
        } | null;
        readonly projectPersons: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly person: {
                readonly id: string;
                readonly firstName: string | null;
                readonly lastName: string | null;
                readonly fullName: string | null;
                readonly profilePictureId: string | null;
                readonly profilePictureDefaultId: number | null;
                readonly active: boolean | null;
                readonly permissions: ReadonlyArray<string | null> | null;
                readonly harvestUser: boolean | null;
              } | null;
              readonly project: {
                readonly id: string;
              } | null;
              readonly role: {
                readonly id: string;
                readonly name: string | null;
              } | null;
            } | null;
          } | null> | null;
        } | null;
        readonly client: {
          readonly id: string;
          readonly name: string;
          readonly logoId: string | null;
          readonly logoDefaultId: number | null;
        } | null;
        readonly phases: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly name: string | null;
              readonly startYear: number | null;
              readonly startMonth: number | null;
              readonly startDay: number | null;
              readonly deadlineYear: number | null;
              readonly deadlineMonth: number | null;
              readonly deadlineDay: number | null;
            } | null;
          } | null> | null;
        } | null;
        readonly statusColumnsV2: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly name: string | null;
              readonly category: STATUS_CATEGORY | null;
              readonly order: number | null;
              readonly jiraStatusId: string | null;
              readonly adoState: string | null;
              readonly projectGroupStatusColumnId: number | null;
              readonly userActions: {
                readonly canDelete: boolean | null;
                readonly canDeleteWithTasks: boolean | null;
                readonly canCreateTask: boolean | null;
                readonly canRename: boolean | null;
              } | null;
            } | null;
          } | null> | null;
        } | null;
        readonly sprints: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly name: string | null;
              readonly startYear: number | null;
              readonly startMonth: number | null;
              readonly startDay: number | null;
              readonly endYear: number | null;
              readonly endMonth: number | null;
              readonly endDay: number | null;
            } | null;
          } | null> | null;
        } | null;
        readonly completion: number | null;
        readonly remaining: number | null;
        readonly forecast: number | null;
        readonly " $fragmentSpreads": FragmentRefs<"DeprecatedProjectIndicatorJS_project">;
      } | null;
      readonly done: boolean | null;
      readonly estimateForecastMinutes: number | null;
      readonly progress: number | null;
      readonly " $fragmentSpreads": FragmentRefs<"DraggableCard_task">;
    } | null> | null;
    readonly taskEdge: {
      readonly node: {
        readonly id: string;
        readonly userCanDeleteTask: boolean | null;
        readonly userCantDeleteTaskReason: CANT_DELETE_TASK_REASON | null;
        readonly fullAccessToProject: boolean | null;
        readonly approved: boolean | null;
        readonly name: string | null;
        readonly readOnly: {
          readonly isReadOnly: boolean | null;
        } | null;
        readonly coverFile: {
          readonly id: string;
        } | null;
        readonly parentTaskId: string | null;
        readonly parentTask: {
          readonly id: string;
          readonly companyTaskId: number | null;
          readonly name: string | null;
          readonly parentTask: {
            readonly id: string;
            readonly companyTaskId: number | null;
            readonly name: string | null;
          } | null;
        } | null;
        readonly hasChildren: boolean | null;
        readonly companyTaskId: number | null;
        readonly blocked: boolean | null;
        readonly bug: boolean | null;
        readonly billable: boolean | null;
        readonly highPriority: boolean | null;
        readonly startYear: number | null;
        readonly startMonth: number | null;
        readonly startDay: number | null;
        readonly description: string | null;
        readonly jiraId: string | null;
        readonly jiraKey: string | null;
        readonly gitlabIid: string | null;
        readonly vstsId: string | null;
        readonly pipedriveId: string | null;
        readonly isUnit4Task: boolean | null;
        readonly estimateForecast: number | null;
        readonly timeLeft: number | null;
        readonly deadlineDay: number | null;
        readonly deadlineMonth: number | null;
        readonly deadlineYear: number | null;
        readonly startFrom: string | null;
        readonly deadlineFrom: string | null;
        readonly gitlabServerIid: string | null;
        readonly hasLockedTime: boolean | null;
        readonly hasInvoicedTime: boolean | null;
        readonly favoured: boolean | null;
        readonly sageIntacctId: string | null;
        readonly progressDetails: {
          readonly progress: number | null;
        } | null;
        readonly followers: ReadonlyArray<{
          readonly id: string;
          readonly firstName: string | null;
          readonly lastName: string | null;
          readonly profilePictureId: string | null;
          readonly profilePictureDefaultId: number | null;
        } | null> | null;
        readonly taskLabels: ReadonlyArray<{
          readonly label: {
            readonly id: string;
            readonly name: string | null;
            readonly color: string | null;
          } | null;
        } | null> | null;
        readonly subTasks: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly estimate: number | null;
              readonly done: boolean | null;
              readonly sortOrder: number | null;
              readonly name: string | null;
              readonly description: string | null;
              readonly startDay: number | null;
              readonly startMonth: number | null;
              readonly startYear: number | null;
              readonly endDay: number | null;
              readonly endMonth: number | null;
              readonly endYear: number | null;
              readonly startFrom: string | null;
              readonly endFrom: string | null;
              readonly role: {
                readonly id: string;
                readonly name: string | null;
              } | null;
              readonly person: {
                readonly id: string;
                readonly firstName: string | null;
                readonly lastName: string | null;
                readonly active: boolean | null;
                readonly profilePictureId: string | null;
                readonly profilePictureDefaultId: number | null;
              } | null;
            } | null;
          } | null> | null;
        } | null;
        readonly thisTaskDependsOn: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly type: DEPENDENCY_TYPE | null;
              readonly completed: boolean | null;
              readonly taskDependsOnThis: {
                readonly id: string;
                readonly name: string | null;
                readonly companyTaskId: number | null;
                readonly startYear: number | null;
                readonly startMonth: number | null;
                readonly startDay: number | null;
                readonly deadlineDay: number | null;
                readonly deadlineMonth: number | null;
                readonly deadlineYear: number | null;
                readonly statusColumnV2: {
                  readonly id: string;
                  readonly category: STATUS_CATEGORY | null;
                } | null;
              } | null;
              readonly thisDependsOnTask: {
                readonly id: string;
                readonly name: string | null;
                readonly companyTaskId: number | null;
                readonly startYear: number | null;
                readonly startMonth: number | null;
                readonly startDay: number | null;
                readonly deadlineDay: number | null;
                readonly deadlineMonth: number | null;
                readonly deadlineYear: number | null;
                readonly statusColumnV2: {
                  readonly id: string;
                  readonly category: STATUS_CATEGORY | null;
                } | null;
              } | null;
            } | null;
          } | null> | null;
        } | null;
        readonly dependsOnThisTask: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly type: DEPENDENCY_TYPE | null;
              readonly completed: boolean | null;
              readonly taskDependsOnThis: {
                readonly id: string;
                readonly name: string | null;
                readonly companyTaskId: number | null;
                readonly startYear: number | null;
                readonly startMonth: number | null;
                readonly startDay: number | null;
                readonly deadlineDay: number | null;
                readonly deadlineMonth: number | null;
                readonly deadlineYear: number | null;
                readonly statusColumnV2: {
                  readonly id: string;
                  readonly category: STATUS_CATEGORY | null;
                } | null;
              } | null;
              readonly thisDependsOnTask: {
                readonly id: string;
                readonly name: string | null;
                readonly companyTaskId: number | null;
                readonly startYear: number | null;
                readonly startMonth: number | null;
                readonly startDay: number | null;
                readonly deadlineDay: number | null;
                readonly deadlineMonth: number | null;
                readonly deadlineYear: number | null;
                readonly statusColumnV2: {
                  readonly id: string;
                  readonly category: STATUS_CATEGORY | null;
                } | null;
              } | null;
            } | null;
          } | null> | null;
        } | null;
        readonly repeatingTask: {
          readonly id: string;
          readonly repeatType: string | null;
          readonly monday: boolean | null;
          readonly tuesday: boolean | null;
          readonly wednesday: boolean | null;
          readonly thursday: boolean | null;
          readonly friday: boolean | null;
          readonly saturday: boolean | null;
          readonly sunday: boolean | null;
          readonly monthlyDay: number | null;
        } | null;
        readonly statusColumnV2: {
          readonly id: string;
          readonly name: string | null;
          readonly category: STATUS_CATEGORY | null;
          readonly projectGroupStatusColumnId: number | null;
        } | null;
        readonly phase: {
          readonly id: string;
          readonly name: string | null;
          readonly startYear: number | null;
          readonly startMonth: number | null;
          readonly startDay: number | null;
          readonly deadlineDay: number | null;
          readonly deadlineMonth: number | null;
          readonly deadlineYear: number | null;
        } | null;
        readonly sprint: {
          readonly id: string;
          readonly name: string | null;
          readonly startYear: number | null;
          readonly startMonth: number | null;
          readonly startDay: number | null;
          readonly endDay: number | null;
          readonly endMonth: number | null;
          readonly endYear: number | null;
        } | null;
        readonly assignedPersons: ReadonlyArray<{
          readonly id: string;
          readonly firstName: string | null;
          readonly lastName: string | null;
          readonly role: {
            readonly id: string;
            readonly name: string | null;
          } | null;
          readonly profilePictureId: string | null;
          readonly profilePictureDefaultId: number | null;
          readonly email: string | null;
        } | null> | null;
        readonly timeRegistrations: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly invoiced: boolean | null;
              readonly xeroInvoiceId: string | null;
              readonly minutesRegistered: number | null;
              readonly lockedInPeriod: boolean | null;
            } | null;
          } | null> | null;
        } | null;
        readonly role: {
          readonly id: string;
          readonly name: string | null;
        } | null;
        readonly googleDriveFiles: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string | null;
              readonly name: string | null;
              readonly link: string | null;
              readonly thumb: string | null;
            } | null;
          } | null> | null;
        } | null;
        readonly files: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly name: string | null;
              readonly mimeType: string | null;
              readonly key: string | null;
              readonly size: number | null;
              readonly yearCreated: number | null;
              readonly monthCreated: number | null;
              readonly dayCreated: number | null;
              readonly hourCreated: number | null;
              readonly minuteCreated: number | null;
              readonly secondCreated: number | null;
              readonly person: {
                readonly id: string;
                readonly fullName: string | null;
              } | null;
            } | null;
          } | null> | null;
        } | null;
        readonly commentCount: number | null;
        readonly comments: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly comment: string | null;
              readonly year: number | null;
              readonly month: number | null;
              readonly day: number | null;
              readonly hours: number | null;
              readonly minutes: number | null;
              readonly seconds: number | null;
              readonly person: {
                readonly id: string;
                readonly firstName: string | null;
                readonly lastName: string | null;
                readonly fullName: string | null;
                readonly profilePictureId: string | null;
                readonly profilePictureDefaultId: number | null;
              } | null;
            } | null;
          } | null> | null;
        } | null;
        readonly createdAt: string | null;
        readonly createdBy: {
          readonly id: string;
          readonly firstName: string | null;
          readonly lastName: string | null;
        } | null;
        readonly latestUiUpdateAt: string | null;
        readonly latestUiUpdateBy: {
          readonly id: string;
          readonly firstName: string | null;
          readonly lastName: string | null;
        } | null;
        readonly owner: {
          readonly id: string;
          readonly firstName: string | null;
          readonly lastName: string | null;
          readonly fullName: string | null;
          readonly profilePictureId: string | null;
          readonly profilePictureDefaultId: number | null;
          readonly role: {
            readonly id: string;
            readonly name: string | null;
          } | null;
        } | null;
        readonly project: {
          readonly id: string;
          readonly name: string | null;
          readonly useTaskOwner: boolean | null;
          readonly useTaskFollowers: boolean | null;
          readonly useTaskHierarchy: boolean | null;
          readonly projectStartYear: number | null;
          readonly projectStartMonth: number | null;
          readonly projectStartDay: number | null;
          readonly projectEndYear: number | null;
          readonly projectEndMonth: number | null;
          readonly projectEndDay: number | null;
          readonly status: PROJECT_STATUS | null;
          readonly projectColor: string | null;
          readonly isJiraProject: boolean | null;
          readonly jiraSubtaskType: string | null;
          readonly jiraCloudProject: {
            readonly id: string;
          } | null;
          readonly jiraCloudEpicIds: ReadonlyArray<string | null> | null;
          readonly jiraServerProject: {
            readonly id: string;
          } | null;
          readonly gitlabProjectName: string | null;
          readonly gitlabServerProjectName: string | null;
          readonly projectGroupId: string | null;
          readonly billable: boolean | null;
          readonly taskLevels: number | null;
          readonly companyProjectId: number | null;
          readonly customProjectId: string | null;
          readonly isProgramRevenueLocked: boolean | null;
          readonly programBudgetType: PROGRAM_BUDGET_TYPE | null;
          readonly program: {
            readonly name: string | null;
            readonly prefix: string | null;
            readonly budgetType: PROGRAM_BUDGET_TYPE | null;
            readonly members: {
              readonly edges: ReadonlyArray<{
                readonly node: {
                  readonly role: string | null;
                  readonly person: {
                    readonly id: string;
                  } | null;
                } | null;
              } | null> | null;
            } | null;
          } | null;
          readonly harvestProject: {
            readonly id: string;
          } | null;
          readonly manualProgressOnProjectEnabled: boolean | null;
          readonly manualProgressOnPhasesEnabled: boolean | null;
          readonly manualProgressOnTasksEnabled: boolean | null;
          readonly vstsProject: string | null;
          readonly vstsAccount: string | null;
          readonly vstsTwoWaySync: boolean | null;
          readonly sprintTimeBox: boolean | null;
          readonly estimationUnit: string | null;
          readonly remainingAutoCalculated: boolean | null;
          readonly rateCard: {
            readonly id: string;
            readonly disabledRoles: ReadonlyArray<{
              readonly id: string;
            } | null> | null;
          } | null;
          readonly projectPersons: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly person: {
                  readonly id: string;
                  readonly firstName: string | null;
                  readonly lastName: string | null;
                  readonly fullName: string | null;
                  readonly profilePictureId: string | null;
                  readonly profilePictureDefaultId: number | null;
                  readonly active: boolean | null;
                  readonly permissions: ReadonlyArray<string | null> | null;
                  readonly harvestUser: boolean | null;
                } | null;
                readonly project: {
                  readonly id: string;
                } | null;
                readonly role: {
                  readonly id: string;
                  readonly name: string | null;
                } | null;
              } | null;
            } | null> | null;
          } | null;
          readonly client: {
            readonly id: string;
            readonly name: string;
            readonly logoId: string | null;
            readonly logoDefaultId: number | null;
          } | null;
          readonly phases: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly name: string | null;
                readonly startYear: number | null;
                readonly startMonth: number | null;
                readonly startDay: number | null;
                readonly deadlineYear: number | null;
                readonly deadlineMonth: number | null;
                readonly deadlineDay: number | null;
              } | null;
            } | null> | null;
          } | null;
          readonly statusColumnsV2: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly name: string | null;
                readonly category: STATUS_CATEGORY | null;
                readonly order: number | null;
                readonly jiraStatusId: string | null;
                readonly adoState: string | null;
                readonly projectGroupStatusColumnId: number | null;
                readonly userActions: {
                  readonly canDelete: boolean | null;
                  readonly canDeleteWithTasks: boolean | null;
                  readonly canCreateTask: boolean | null;
                  readonly canRename: boolean | null;
                } | null;
              } | null;
            } | null> | null;
          } | null;
          readonly sprints: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly name: string | null;
                readonly startYear: number | null;
                readonly startMonth: number | null;
                readonly startDay: number | null;
                readonly endYear: number | null;
                readonly endMonth: number | null;
                readonly endDay: number | null;
              } | null;
            } | null> | null;
          } | null;
          readonly completion: number | null;
          readonly remaining: number | null;
          readonly forecast: number | null;
          readonly " $fragmentSpreads": FragmentRefs<"DeprecatedProjectIndicatorJS_project">;
        } | null;
        readonly done: boolean | null;
        readonly estimateForecastMinutes: number | null;
        readonly progress: number | null;
        readonly " $fragmentSpreads": FragmentRefs<"DraggableCard_task">;
      } | null;
    } | null;
  } | null;
};
export type moveTaskToAnotherProjectMutation = {
  variables: moveTaskToAnotherProjectMutation$variables;
  response: moveTaskToAnotherProjectMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedTasksIds",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userCanDeleteTask",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userCantDeleteTaskReason",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullAccessToProject",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "approved",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isReadOnly",
  "storageKey": null
},
v11 = [
  (v4/*: any*/)
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parentTaskId",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyTaskId",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "Task",
  "kind": "LinkedField",
  "name": "parentTask",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v13/*: any*/),
    (v9/*: any*/)
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasChildren",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "blocked",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bug",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billable",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "highPriority",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startYear",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startMonth",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDay",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraId",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraKey",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gitlabIid",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vstsId",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pipedriveId",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isUnit4Task",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimateForecast",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timeLeft",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineDay",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineMonth",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineYear",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startFrom",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineFrom",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gitlabServerIid",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasLockedTime",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasInvoicedTime",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "favoured",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sageIntacctId",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "progress",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureId",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureDefaultId",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "followers",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    (v43/*: any*/),
    (v44/*: any*/),
    (v45/*: any*/),
    (v46/*: any*/)
  ],
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "concreteType": "Label",
  "kind": "LinkedField",
  "name": "label",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "done",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDay",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endMonth",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endYear",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v9/*: any*/)
  ],
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v58 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "SubTaskTypeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SubTask",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "estimate",
            "storageKey": null
          },
          (v49/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sortOrder",
            "storageKey": null
          },
          (v9/*: any*/),
          (v23/*: any*/),
          (v22/*: any*/),
          (v21/*: any*/),
          (v20/*: any*/),
          (v50/*: any*/),
          (v51/*: any*/),
          (v52/*: any*/),
          (v35/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endFrom",
            "storageKey": null
          },
          (v53/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Person",
            "kind": "LinkedField",
            "name": "person",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v43/*: any*/),
              (v44/*: any*/),
              (v54/*: any*/),
              (v45/*: any*/),
              (v46/*: any*/)
            ],
            "storageKey": null
          },
          (v55/*: any*/)
        ],
        "storageKey": null
      },
      (v56/*: any*/)
    ],
    "storageKey": null
  },
  (v57/*: any*/)
],
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "completed",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v62 = [
  (v4/*: any*/),
  (v9/*: any*/),
  (v13/*: any*/),
  (v20/*: any*/),
  (v21/*: any*/),
  (v22/*: any*/),
  (v32/*: any*/),
  (v33/*: any*/),
  (v34/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "StatusColumnV2",
    "kind": "LinkedField",
    "name": "statusColumnV2",
    "plural": false,
    "selections": [
      (v4/*: any*/),
      (v61/*: any*/)
    ],
    "storageKey": null
  }
],
v63 = {
  "alias": null,
  "args": null,
  "concreteType": "Task",
  "kind": "LinkedField",
  "name": "taskDependsOnThis",
  "plural": false,
  "selections": (v62/*: any*/),
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "concreteType": "Task",
  "kind": "LinkedField",
  "name": "thisDependsOnTask",
  "plural": false,
  "selections": (v62/*: any*/),
  "storageKey": null
},
v65 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "DependencyTypeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "DependencyType",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v59/*: any*/),
          (v60/*: any*/),
          (v63/*: any*/),
          (v64/*: any*/),
          (v55/*: any*/)
        ],
        "storageKey": null
      },
      (v56/*: any*/)
    ],
    "storageKey": null
  },
  (v57/*: any*/)
],
v66 = {
  "alias": null,
  "args": null,
  "concreteType": "RepeatingTask",
  "kind": "LinkedField",
  "name": "repeatingTask",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "repeatType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "monday",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tuesday",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "wednesday",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "thursday",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "friday",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "saturday",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sunday",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "monthlyDay",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectGroupStatusColumnId",
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "concreteType": "PhaseType",
  "kind": "LinkedField",
  "name": "phase",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v9/*: any*/),
    (v20/*: any*/),
    (v21/*: any*/),
    (v22/*: any*/),
    (v32/*: any*/),
    (v33/*: any*/),
    (v34/*: any*/)
  ],
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "concreteType": "Sprint",
  "kind": "LinkedField",
  "name": "sprint",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v9/*: any*/),
    (v20/*: any*/),
    (v21/*: any*/),
    (v22/*: any*/),
    (v50/*: any*/),
    (v51/*: any*/),
    (v52/*: any*/)
  ],
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v71 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "TimeRegTypeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TimeRegType",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "invoiced",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "xeroInvoiceId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "minutesRegistered",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lockedInPeriod",
            "storageKey": null
          },
          (v55/*: any*/)
        ],
        "storageKey": null
      },
      (v56/*: any*/)
    ],
    "storageKey": null
  },
  (v57/*: any*/)
],
v72 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "GoogleDriveFileTypeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GoogleDriveFile",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "link",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "thumb",
            "storageKey": null
          },
          (v55/*: any*/)
        ],
        "storageKey": null
      },
      (v56/*: any*/)
    ],
    "storageKey": null
  },
  (v57/*: any*/)
],
v73 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v74 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v75 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "FileTypeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "File",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "mimeType",
            "storageKey": null
          },
          (v73/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "size",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "yearCreated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "monthCreated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dayCreated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hourCreated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "minuteCreated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "secondCreated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Person",
            "kind": "LinkedField",
            "name": "person",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v74/*: any*/)
            ],
            "storageKey": null
          },
          (v55/*: any*/)
        ],
        "storageKey": null
      },
      (v56/*: any*/)
    ],
    "storageKey": null
  },
  (v57/*: any*/)
],
v76 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "commentCount",
  "storageKey": null
},
v77 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CommentTypeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CommentType",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "comment",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "year",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "month",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "day",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hours",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "minutes",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "seconds",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Person",
            "kind": "LinkedField",
            "name": "person",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v43/*: any*/),
              (v44/*: any*/),
              (v74/*: any*/),
              (v45/*: any*/),
              (v46/*: any*/)
            ],
            "storageKey": null
          },
          (v55/*: any*/)
        ],
        "storageKey": null
      },
      (v56/*: any*/)
    ],
    "storageKey": null
  },
  (v57/*: any*/)
],
v78 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v79 = [
  (v4/*: any*/),
  (v43/*: any*/),
  (v44/*: any*/)
],
v80 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "createdBy",
  "plural": false,
  "selections": (v79/*: any*/),
  "storageKey": null
},
v81 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "latestUiUpdateAt",
  "storageKey": null
},
v82 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "latestUiUpdateBy",
  "plural": false,
  "selections": (v79/*: any*/),
  "storageKey": null
},
v83 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v43/*: any*/),
    (v44/*: any*/),
    (v74/*: any*/),
    (v45/*: any*/),
    (v46/*: any*/),
    (v53/*: any*/)
  ],
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "useTaskOwner",
  "storageKey": null
},
v85 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "useTaskFollowers",
  "storageKey": null
},
v86 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "useTaskHierarchy",
  "storageKey": null
},
v87 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartYear",
  "storageKey": null
},
v88 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartMonth",
  "storageKey": null
},
v89 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartDay",
  "storageKey": null
},
v90 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndYear",
  "storageKey": null
},
v91 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndMonth",
  "storageKey": null
},
v92 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndDay",
  "storageKey": null
},
v93 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v94 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectColor",
  "storageKey": null
},
v95 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isJiraProject",
  "storageKey": null
},
v96 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraSubtaskType",
  "storageKey": null
},
v97 = {
  "alias": null,
  "args": null,
  "concreteType": "JiraCloudProjectType",
  "kind": "LinkedField",
  "name": "jiraCloudProject",
  "plural": false,
  "selections": (v11/*: any*/),
  "storageKey": null
},
v98 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraCloudEpicIds",
  "storageKey": null
},
v99 = {
  "alias": null,
  "args": null,
  "concreteType": "JiraServerProjectType",
  "kind": "LinkedField",
  "name": "jiraServerProject",
  "plural": false,
  "selections": (v11/*: any*/),
  "storageKey": null
},
v100 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gitlabProjectName",
  "storageKey": null
},
v101 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gitlabServerProjectName",
  "storageKey": null
},
v102 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectGroupId",
  "storageKey": null
},
v103 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "taskLevels",
  "storageKey": null
},
v104 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyProjectId",
  "storageKey": null
},
v105 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customProjectId",
  "storageKey": null
},
v106 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isProgramRevenueLocked",
  "storageKey": null
},
v107 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "programBudgetType",
  "storageKey": null
},
v108 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "prefix",
  "storageKey": null
},
v109 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "budgetType",
  "storageKey": null
},
v110 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role",
  "storageKey": null
},
v111 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "person",
  "plural": false,
  "selections": (v11/*: any*/),
  "storageKey": null
},
v112 = {
  "alias": null,
  "args": null,
  "concreteType": "HarvestProjectType",
  "kind": "LinkedField",
  "name": "harvestProject",
  "plural": false,
  "selections": (v11/*: any*/),
  "storageKey": null
},
v113 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "manualProgressOnProjectEnabled",
  "storageKey": null
},
v114 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "manualProgressOnPhasesEnabled",
  "storageKey": null
},
v115 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "manualProgressOnTasksEnabled",
  "storageKey": null
},
v116 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vstsProject",
  "storageKey": null
},
v117 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vstsAccount",
  "storageKey": null
},
v118 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vstsTwoWaySync",
  "storageKey": null
},
v119 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sprintTimeBox",
  "storageKey": null
},
v120 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimationUnit",
  "storageKey": null
},
v121 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "remainingAutoCalculated",
  "storageKey": null
},
v122 = {
  "alias": null,
  "args": null,
  "concreteType": "RateCard",
  "kind": "LinkedField",
  "name": "rateCard",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Role",
      "kind": "LinkedField",
      "name": "disabledRoles",
      "plural": true,
      "selections": (v11/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v123 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "permissions",
  "storageKey": null
},
v124 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ProjectPersonTypeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectPerson",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Person",
            "kind": "LinkedField",
            "name": "person",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v43/*: any*/),
              (v44/*: any*/),
              (v74/*: any*/),
              (v45/*: any*/),
              (v46/*: any*/),
              (v54/*: any*/),
              (v123/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "harvestUser",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          (v53/*: any*/),
          (v55/*: any*/)
        ],
        "storageKey": null
      },
      (v56/*: any*/)
    ],
    "storageKey": null
  },
  (v57/*: any*/)
],
v125 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logoId",
  "storageKey": null
},
v126 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logoDefaultId",
  "storageKey": null
},
v127 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10000
  }
],
v128 = {
  "alias": null,
  "args": (v127/*: any*/),
  "concreteType": "PhaseTypeConnection",
  "kind": "LinkedField",
  "name": "phases",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PhaseTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PhaseType",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            (v9/*: any*/),
            (v20/*: any*/),
            (v21/*: any*/),
            (v22/*: any*/),
            (v34/*: any*/),
            (v33/*: any*/),
            (v32/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "phases(first:10000)"
},
v129 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000000
  }
],
v130 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "order",
  "storageKey": null
},
v131 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraStatusId",
  "storageKey": null
},
v132 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "adoState",
  "storageKey": null
},
v133 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canDelete",
  "storageKey": null
},
v134 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canDeleteWithTasks",
  "storageKey": null
},
v135 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canCreateTask",
  "storageKey": null
},
v136 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canRename",
  "storageKey": null
},
v137 = {
  "alias": null,
  "args": (v127/*: any*/),
  "concreteType": "SprintTypeConnection",
  "kind": "LinkedField",
  "name": "sprints",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SprintTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Sprint",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            (v9/*: any*/),
            (v20/*: any*/),
            (v21/*: any*/),
            (v22/*: any*/),
            (v52/*: any*/),
            (v51/*: any*/),
            (v50/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "sprints(first:10000)"
},
v138 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "completion",
  "storageKey": null
},
v139 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "remaining",
  "storageKey": null
},
v140 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "forecast",
  "storageKey": null
},
v141 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimateForecastMinutes",
  "storageKey": null
},
v142 = [
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "DraggableCard_task"
  },
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "TaskReadOnly",
    "kind": "LinkedField",
    "name": "readOnly",
    "plural": false,
    "selections": [
      (v10/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "File",
    "kind": "LinkedField",
    "name": "coverFile",
    "plural": false,
    "selections": (v11/*: any*/),
    "storageKey": null
  },
  (v12/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Task",
    "kind": "LinkedField",
    "name": "parentTask",
    "plural": false,
    "selections": [
      (v4/*: any*/),
      (v13/*: any*/),
      (v9/*: any*/),
      (v14/*: any*/)
    ],
    "storageKey": null
  },
  (v15/*: any*/),
  (v13/*: any*/),
  (v16/*: any*/),
  (v17/*: any*/),
  (v18/*: any*/),
  (v19/*: any*/),
  (v20/*: any*/),
  (v21/*: any*/),
  (v22/*: any*/),
  (v23/*: any*/),
  (v24/*: any*/),
  (v25/*: any*/),
  (v26/*: any*/),
  (v27/*: any*/),
  (v28/*: any*/),
  (v29/*: any*/),
  (v30/*: any*/),
  (v31/*: any*/),
  (v32/*: any*/),
  (v33/*: any*/),
  (v34/*: any*/),
  (v35/*: any*/),
  (v36/*: any*/),
  (v37/*: any*/),
  (v38/*: any*/),
  (v39/*: any*/),
  (v40/*: any*/),
  (v41/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "TaskProgress",
    "kind": "LinkedField",
    "name": "progressDetails",
    "plural": false,
    "selections": [
      (v42/*: any*/)
    ],
    "storageKey": null
  },
  (v47/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "TaskLabel",
    "kind": "LinkedField",
    "name": "taskLabels",
    "plural": true,
    "selections": [
      (v48/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": "subTasks",
    "args": null,
    "concreteType": "SubTaskTypeConnection",
    "kind": "LinkedField",
    "name": "__Task_subTasks_connection",
    "plural": false,
    "selections": (v58/*: any*/),
    "storageKey": null
  },
  {
    "alias": "thisTaskDependsOn",
    "args": null,
    "concreteType": "DependencyTypeConnection",
    "kind": "LinkedField",
    "name": "__Task_thisTaskDependsOn_connection",
    "plural": false,
    "selections": (v65/*: any*/),
    "storageKey": null
  },
  {
    "alias": "dependsOnThisTask",
    "args": null,
    "concreteType": "DependencyTypeConnection",
    "kind": "LinkedField",
    "name": "__Task_dependsOnThisTask_connection",
    "plural": false,
    "selections": (v65/*: any*/),
    "storageKey": null
  },
  (v66/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "StatusColumnV2",
    "kind": "LinkedField",
    "name": "statusColumnV2",
    "plural": false,
    "selections": [
      (v4/*: any*/),
      (v9/*: any*/),
      (v61/*: any*/),
      (v67/*: any*/)
    ],
    "storageKey": null
  },
  (v68/*: any*/),
  (v69/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Person",
    "kind": "LinkedField",
    "name": "assignedPersons",
    "plural": true,
    "selections": [
      (v4/*: any*/),
      (v43/*: any*/),
      (v44/*: any*/),
      (v53/*: any*/),
      (v45/*: any*/),
      (v46/*: any*/),
      (v70/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": "timeRegistrations",
    "args": null,
    "concreteType": "TimeRegTypeConnection",
    "kind": "LinkedField",
    "name": "__Task_timeRegistrations_connection",
    "plural": false,
    "selections": (v71/*: any*/),
    "storageKey": null
  },
  (v53/*: any*/),
  {
    "alias": "googleDriveFiles",
    "args": null,
    "concreteType": "GoogleDriveFileTypeConnection",
    "kind": "LinkedField",
    "name": "__Task_googleDriveFiles_connection",
    "plural": false,
    "selections": (v72/*: any*/),
    "storageKey": null
  },
  {
    "alias": "files",
    "args": null,
    "concreteType": "FileTypeConnection",
    "kind": "LinkedField",
    "name": "__Task_files_connection",
    "plural": false,
    "selections": (v75/*: any*/),
    "storageKey": null
  },
  (v76/*: any*/),
  {
    "alias": "comments",
    "args": null,
    "concreteType": "CommentTypeConnection",
    "kind": "LinkedField",
    "name": "__Task_comments_connection",
    "plural": false,
    "selections": (v77/*: any*/),
    "storageKey": null
  },
  (v78/*: any*/),
  (v80/*: any*/),
  (v81/*: any*/),
  (v82/*: any*/),
  (v83/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "ProjectType",
    "kind": "LinkedField",
    "name": "project",
    "plural": false,
    "selections": [
      (v4/*: any*/),
      (v9/*: any*/),
      (v84/*: any*/),
      (v85/*: any*/),
      (v86/*: any*/),
      (v87/*: any*/),
      (v88/*: any*/),
      (v89/*: any*/),
      (v90/*: any*/),
      (v91/*: any*/),
      (v92/*: any*/),
      (v93/*: any*/),
      (v94/*: any*/),
      (v95/*: any*/),
      (v96/*: any*/),
      (v97/*: any*/),
      (v98/*: any*/),
      (v99/*: any*/),
      (v100/*: any*/),
      (v101/*: any*/),
      (v102/*: any*/),
      (v18/*: any*/),
      (v103/*: any*/),
      (v104/*: any*/),
      (v105/*: any*/),
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "DeprecatedProjectIndicatorJS_project"
      },
      (v106/*: any*/),
      (v107/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "ProgramType",
        "kind": "LinkedField",
        "name": "program",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          (v108/*: any*/),
          (v109/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectServiceProgramMemberTypeConnection",
            "kind": "LinkedField",
            "name": "members",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectServiceProgramMemberTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectServiceProgramMemberType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v110/*: any*/),
                      (v111/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v112/*: any*/),
      (v113/*: any*/),
      (v114/*: any*/),
      (v115/*: any*/),
      (v116/*: any*/),
      (v117/*: any*/),
      (v118/*: any*/),
      (v119/*: any*/),
      (v120/*: any*/),
      (v121/*: any*/),
      (v122/*: any*/),
      {
        "alias": "projectPersons",
        "args": null,
        "concreteType": "ProjectPersonTypeConnection",
        "kind": "LinkedField",
        "name": "__Project_projectPersons_connection",
        "plural": false,
        "selections": (v124/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Client",
        "kind": "LinkedField",
        "name": "client",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v9/*: any*/),
          (v125/*: any*/),
          (v126/*: any*/)
        ],
        "storageKey": null
      },
      (v128/*: any*/),
      {
        "alias": null,
        "args": (v129/*: any*/),
        "concreteType": "StatusColumnV2TypeConnection",
        "kind": "LinkedField",
        "name": "statusColumnsV2",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StatusColumnV2TypeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "StatusColumnV2",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v9/*: any*/),
                  (v61/*: any*/),
                  (v130/*: any*/),
                  (v131/*: any*/),
                  (v132/*: any*/),
                  (v67/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StatusColumnUserActions",
                    "kind": "LinkedField",
                    "name": "userActions",
                    "plural": false,
                    "selections": [
                      (v133/*: any*/),
                      (v134/*: any*/),
                      (v135/*: any*/),
                      (v136/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "statusColumnsV2(first:1000000)"
      },
      (v137/*: any*/),
      (v138/*: any*/),
      (v139/*: any*/),
      (v140/*: any*/)
    ],
    "storageKey": null
  },
  (v49/*: any*/),
  (v141/*: any*/),
  (v42/*: any*/)
],
v143 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v144 = {
  "alias": null,
  "args": null,
  "concreteType": "StatusColumnV2",
  "kind": "LinkedField",
  "name": "statusColumnV2",
  "plural": false,
  "selections": [
    (v61/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v145 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 5000
  }
],
v146 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100000
  }
],
v147 = [
  (v4/*: any*/),
  (v18/*: any*/),
  (v81/*: any*/),
  (v23/*: any*/),
  (v31/*: any*/),
  (v42/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "favouredSortOrder",
    "storageKey": null
  },
  (v141/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalMinutesRegistered",
    "storageKey": null
  },
  (v13/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "TaskReadOnly",
    "kind": "LinkedField",
    "name": "readOnly",
    "plural": false,
    "selections": [
      (v10/*: any*/),
      (v4/*: any*/)
    ],
    "storageKey": null
  },
  (v5/*: any*/),
  (v6/*: any*/),
  (v15/*: any*/),
  (v41/*: any*/),
  (v9/*: any*/),
  (v40/*: any*/),
  (v19/*: any*/),
  (v17/*: any*/),
  (v16/*: any*/),
  (v22/*: any*/),
  (v21/*: any*/),
  (v20/*: any*/),
  (v32/*: any*/),
  (v33/*: any*/),
  (v24/*: any*/),
  (v27/*: any*/),
  (v34/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "subTaskCount",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fileCount",
    "storageKey": null
  },
  (v76/*: any*/),
  (v49/*: any*/),
  (v12/*: any*/),
  (v39/*: any*/),
  (v53/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Task",
    "kind": "LinkedField",
    "name": "parentTask",
    "plural": false,
    "selections": [
      (v9/*: any*/),
      (v4/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "StatusColumnV2",
    "kind": "LinkedField",
    "name": "statusColumnV2",
    "plural": false,
    "selections": [
      (v4/*: any*/),
      (v61/*: any*/),
      (v67/*: any*/),
      (v9/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "TaskLabel",
    "kind": "LinkedField",
    "name": "taskLabels",
    "plural": true,
    "selections": [
      (v4/*: any*/),
      (v48/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "File",
    "kind": "LinkedField",
    "name": "coverFile",
    "plural": false,
    "selections": [
      (v4/*: any*/),
      (v9/*: any*/),
      (v73/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "ProjectType",
    "kind": "LinkedField",
    "name": "project",
    "plural": false,
    "selections": [
      (v4/*: any*/),
      (v104/*: any*/),
      (v94/*: any*/),
      (v9/*: any*/),
      (v93/*: any*/),
      (v87/*: any*/),
      (v88/*: any*/),
      (v89/*: any*/),
      (v90/*: any*/),
      (v91/*: any*/),
      (v92/*: any*/),
      (v102/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Unit4ProjectType",
        "kind": "LinkedField",
        "name": "unit4Project",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "activitiesEnabled",
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      (v112/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Client",
        "kind": "LinkedField",
        "name": "client",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          (v125/*: any*/),
          (v126/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      (v106/*: any*/),
      (v107/*: any*/),
      (v105/*: any*/),
      (v84/*: any*/),
      (v85/*: any*/),
      (v86/*: any*/),
      (v95/*: any*/),
      (v96/*: any*/),
      (v97/*: any*/),
      (v98/*: any*/),
      (v99/*: any*/),
      (v100/*: any*/),
      (v101/*: any*/),
      (v18/*: any*/),
      (v103/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "ProgramType",
        "kind": "LinkedField",
        "name": "program",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          (v108/*: any*/),
          (v109/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectServiceProgramMemberTypeConnection",
            "kind": "LinkedField",
            "name": "members",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectServiceProgramMemberTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectServiceProgramMemberType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v110/*: any*/),
                      (v111/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      (v113/*: any*/),
      (v114/*: any*/),
      (v115/*: any*/),
      (v116/*: any*/),
      (v117/*: any*/),
      (v118/*: any*/),
      (v119/*: any*/),
      (v120/*: any*/),
      (v121/*: any*/),
      (v122/*: any*/),
      {
        "alias": null,
        "args": (v127/*: any*/),
        "concreteType": "ProjectPersonTypeConnection",
        "kind": "LinkedField",
        "name": "projectPersons",
        "plural": false,
        "selections": (v124/*: any*/),
        "storageKey": "projectPersons(first:10000)"
      },
      {
        "alias": null,
        "args": (v127/*: any*/),
        "filters": ([]/*: any*/),
        "handle": "connection",
        "key": "Project_projectPersons",
        "kind": "LinkedHandle",
        "name": "projectPersons"
      },
      (v128/*: any*/),
      {
        "alias": null,
        "args": (v129/*: any*/),
        "concreteType": "StatusColumnV2TypeConnection",
        "kind": "LinkedField",
        "name": "statusColumnsV2",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StatusColumnV2TypeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "StatusColumnV2",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v9/*: any*/),
                  (v61/*: any*/),
                  (v130/*: any*/),
                  (v131/*: any*/),
                  (v132/*: any*/),
                  (v67/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StatusColumnUserActions",
                    "kind": "LinkedField",
                    "name": "userActions",
                    "plural": false,
                    "selections": [
                      (v133/*: any*/),
                      (v134/*: any*/),
                      (v135/*: any*/),
                      (v136/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "statusColumnsV2(first:1000000)"
      },
      (v137/*: any*/),
      (v138/*: any*/),
      (v139/*: any*/),
      (v140/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": (v143/*: any*/),
    "concreteType": "DependencyTypeConnection",
    "kind": "LinkedField",
    "name": "thisTaskDependsOn",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "DependencyTypeEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DependencyType",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v59/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Task",
                "kind": "LinkedField",
                "name": "thisDependsOnTask",
                "plural": false,
                "selections": [
                  (v144/*: any*/),
                  (v4/*: any*/),
                  (v9/*: any*/),
                  (v13/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v32/*: any*/),
                  (v33/*: any*/),
                  (v34/*: any*/)
                ],
                "storageKey": null
              },
              (v55/*: any*/),
              (v60/*: any*/),
              (v63/*: any*/)
            ],
            "storageKey": null
          },
          (v56/*: any*/)
        ],
        "storageKey": null
      },
      (v57/*: any*/)
    ],
    "storageKey": "thisTaskDependsOn(first:1000)"
  },
  {
    "alias": null,
    "args": (v143/*: any*/),
    "filters": null,
    "handle": "connection",
    "key": "Task_thisTaskDependsOn",
    "kind": "LinkedHandle",
    "name": "thisTaskDependsOn"
  },
  {
    "alias": null,
    "args": (v143/*: any*/),
    "concreteType": "DependencyTypeConnection",
    "kind": "LinkedField",
    "name": "dependsOnThisTask",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "DependencyTypeEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DependencyType",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v59/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Task",
                "kind": "LinkedField",
                "name": "taskDependsOnThis",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v144/*: any*/),
                  (v9/*: any*/),
                  (v13/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v32/*: any*/),
                  (v33/*: any*/),
                  (v34/*: any*/)
                ],
                "storageKey": null
              },
              (v55/*: any*/),
              (v60/*: any*/),
              (v64/*: any*/)
            ],
            "storageKey": null
          },
          (v56/*: any*/)
        ],
        "storageKey": null
      },
      (v57/*: any*/)
    ],
    "storageKey": "dependsOnThisTask(first:1000)"
  },
  {
    "alias": null,
    "args": (v143/*: any*/),
    "filters": null,
    "handle": "connection",
    "key": "Task_dependsOnThisTask",
    "kind": "LinkedHandle",
    "name": "dependsOnThisTask"
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Person",
    "kind": "LinkedField",
    "name": "assignedPersons",
    "plural": true,
    "selections": [
      (v4/*: any*/),
      (v43/*: any*/),
      (v44/*: any*/),
      (v74/*: any*/),
      (v70/*: any*/),
      (v45/*: any*/),
      (v46/*: any*/),
      (v54/*: any*/),
      (v123/*: any*/),
      (v53/*: any*/)
    ],
    "storageKey": null
  },
  (v7/*: any*/),
  (v8/*: any*/),
  (v25/*: any*/),
  (v26/*: any*/),
  (v28/*: any*/),
  (v29/*: any*/),
  (v30/*: any*/),
  (v35/*: any*/),
  (v36/*: any*/),
  (v37/*: any*/),
  (v38/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "TaskProgress",
    "kind": "LinkedField",
    "name": "progressDetails",
    "plural": false,
    "selections": [
      (v42/*: any*/),
      (v4/*: any*/)
    ],
    "storageKey": null
  },
  (v47/*: any*/),
  {
    "alias": null,
    "args": (v143/*: any*/),
    "concreteType": "SubTaskTypeConnection",
    "kind": "LinkedField",
    "name": "subTasks",
    "plural": false,
    "selections": (v58/*: any*/),
    "storageKey": "subTasks(first:1000)"
  },
  {
    "alias": null,
    "args": (v143/*: any*/),
    "filters": null,
    "handle": "connection",
    "key": "Task_subTasks",
    "kind": "LinkedHandle",
    "name": "subTasks"
  },
  (v66/*: any*/),
  (v68/*: any*/),
  (v69/*: any*/),
  {
    "alias": null,
    "args": (v145/*: any*/),
    "concreteType": "TimeRegTypeConnection",
    "kind": "LinkedField",
    "name": "timeRegistrations",
    "plural": false,
    "selections": (v71/*: any*/),
    "storageKey": "timeRegistrations(first:5000)"
  },
  {
    "alias": null,
    "args": (v145/*: any*/),
    "filters": null,
    "handle": "connection",
    "key": "Task_timeRegistrations",
    "kind": "LinkedHandle",
    "name": "timeRegistrations"
  },
  {
    "alias": null,
    "args": (v127/*: any*/),
    "concreteType": "GoogleDriveFileTypeConnection",
    "kind": "LinkedField",
    "name": "googleDriveFiles",
    "plural": false,
    "selections": (v72/*: any*/),
    "storageKey": "googleDriveFiles(first:10000)"
  },
  {
    "alias": null,
    "args": (v127/*: any*/),
    "filters": null,
    "handle": "connection",
    "key": "Task_googleDriveFiles",
    "kind": "LinkedHandle",
    "name": "googleDriveFiles"
  },
  {
    "alias": null,
    "args": (v127/*: any*/),
    "concreteType": "FileTypeConnection",
    "kind": "LinkedField",
    "name": "files",
    "plural": false,
    "selections": (v75/*: any*/),
    "storageKey": "files(first:10000)"
  },
  {
    "alias": null,
    "args": (v127/*: any*/),
    "filters": null,
    "handle": "connection",
    "key": "Task_files",
    "kind": "LinkedHandle",
    "name": "files"
  },
  {
    "alias": null,
    "args": (v146/*: any*/),
    "concreteType": "CommentTypeConnection",
    "kind": "LinkedField",
    "name": "comments",
    "plural": false,
    "selections": (v77/*: any*/),
    "storageKey": "comments(first:100000)"
  },
  {
    "alias": null,
    "args": (v146/*: any*/),
    "filters": null,
    "handle": "connection",
    "key": "Task_comments",
    "kind": "LinkedHandle",
    "name": "comments"
  },
  (v78/*: any*/),
  (v80/*: any*/),
  (v82/*: any*/),
  (v83/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "moveTaskToAnotherProjectMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateTaskPayload",
        "kind": "LinkedField",
        "name": "updateTask",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "tasks",
            "plural": true,
            "selections": (v142/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskTypeEdge",
            "kind": "LinkedField",
            "name": "taskEdge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Task",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": (v142/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "moveTaskToAnotherProjectMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateTaskPayload",
        "kind": "LinkedField",
        "name": "updateTask",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "tasks",
            "plural": true,
            "selections": (v147/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskTypeEdge",
            "kind": "LinkedField",
            "name": "taskEdge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Task",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": (v147/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "923b08094427c2c6522dc23e252c46ad",
    "id": null,
    "metadata": {},
    "name": "moveTaskToAnotherProjectMutation",
    "operationKind": "mutation",
    "text": "mutation moveTaskToAnotherProjectMutation(\n  $input: UpdateTaskInput!\n) {\n  updateTask(input: $input) {\n    errors\n    updatedTasksIds\n    tasks {\n      ...DraggableCard_task\n      id\n      userCanDeleteTask\n      userCantDeleteTaskReason\n      fullAccessToProject\n      approved\n      name\n      readOnly {\n        isReadOnly\n        id\n      }\n      coverFile {\n        id\n      }\n      parentTaskId\n      parentTask {\n        id\n        companyTaskId\n        name\n        parentTask {\n          id\n          companyTaskId\n          name\n        }\n      }\n      hasChildren\n      companyTaskId\n      blocked\n      bug\n      billable\n      highPriority\n      startYear\n      startMonth\n      startDay\n      description\n      jiraId\n      jiraKey\n      gitlabIid\n      vstsId\n      pipedriveId\n      isUnit4Task\n      estimateForecast\n      timeLeft\n      deadlineDay\n      deadlineMonth\n      deadlineYear\n      startFrom\n      deadlineFrom\n      gitlabServerIid\n      hasLockedTime\n      hasInvoicedTime\n      favoured\n      sageIntacctId\n      progressDetails {\n        progress\n        id\n      }\n      followers {\n        id\n        firstName\n        lastName\n        profilePictureId\n        profilePictureDefaultId\n      }\n      taskLabels {\n        label {\n          id\n          name\n          color\n        }\n        id\n      }\n      subTasks(first: 1000) {\n        edges {\n          node {\n            id\n            estimate\n            done\n            sortOrder\n            name\n            description\n            startDay\n            startMonth\n            startYear\n            endDay\n            endMonth\n            endYear\n            startFrom\n            endFrom\n            role {\n              id\n              name\n            }\n            person {\n              id\n              firstName\n              lastName\n              active\n              profilePictureId\n              profilePictureDefaultId\n            }\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n      thisTaskDependsOn(first: 1000) {\n        edges {\n          node {\n            id\n            type\n            completed\n            taskDependsOnThis {\n              id\n              name\n              companyTaskId\n              startYear\n              startMonth\n              startDay\n              deadlineDay\n              deadlineMonth\n              deadlineYear\n              statusColumnV2 {\n                id\n                category\n              }\n            }\n            thisDependsOnTask {\n              id\n              name\n              companyTaskId\n              startYear\n              startMonth\n              startDay\n              deadlineDay\n              deadlineMonth\n              deadlineYear\n              statusColumnV2 {\n                id\n                category\n              }\n            }\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n      dependsOnThisTask(first: 1000) {\n        edges {\n          node {\n            id\n            type\n            completed\n            taskDependsOnThis {\n              id\n              name\n              companyTaskId\n              startYear\n              startMonth\n              startDay\n              deadlineDay\n              deadlineMonth\n              deadlineYear\n              statusColumnV2 {\n                id\n                category\n              }\n            }\n            thisDependsOnTask {\n              id\n              name\n              companyTaskId\n              startYear\n              startMonth\n              startDay\n              deadlineDay\n              deadlineMonth\n              deadlineYear\n              statusColumnV2 {\n                id\n                category\n              }\n            }\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n      repeatingTask {\n        id\n        repeatType\n        monday\n        tuesday\n        wednesday\n        thursday\n        friday\n        saturday\n        sunday\n        monthlyDay\n      }\n      statusColumnV2 {\n        id\n        name\n        category\n        projectGroupStatusColumnId\n      }\n      phase {\n        id\n        name\n        startYear\n        startMonth\n        startDay\n        deadlineDay\n        deadlineMonth\n        deadlineYear\n      }\n      sprint {\n        id\n        name\n        startYear\n        startMonth\n        startDay\n        endDay\n        endMonth\n        endYear\n      }\n      assignedPersons {\n        id\n        firstName\n        lastName\n        role {\n          id\n          name\n        }\n        profilePictureId\n        profilePictureDefaultId\n        email\n      }\n      timeRegistrations(first: 5000) {\n        edges {\n          node {\n            id\n            invoiced\n            xeroInvoiceId\n            minutesRegistered\n            lockedInPeriod\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n      role {\n        id\n        name\n      }\n      googleDriveFiles(first: 10000) {\n        edges {\n          node {\n            id\n            name\n            link\n            thumb\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n      files(first: 10000) {\n        edges {\n          node {\n            id\n            name\n            mimeType\n            key\n            size\n            yearCreated\n            monthCreated\n            dayCreated\n            hourCreated\n            minuteCreated\n            secondCreated\n            person {\n              id\n              fullName\n            }\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n      commentCount\n      comments(first: 100000) {\n        edges {\n          node {\n            id\n            comment\n            year\n            month\n            day\n            hours\n            minutes\n            seconds\n            person {\n              id\n              firstName\n              lastName\n              fullName\n              profilePictureId\n              profilePictureDefaultId\n            }\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n      createdAt\n      createdBy {\n        id\n        firstName\n        lastName\n      }\n      latestUiUpdateAt\n      latestUiUpdateBy {\n        id\n        firstName\n        lastName\n      }\n      owner {\n        id\n        firstName\n        lastName\n        fullName\n        profilePictureId\n        profilePictureDefaultId\n        role {\n          id\n          name\n        }\n      }\n      project {\n        id\n        name\n        useTaskOwner\n        useTaskFollowers\n        useTaskHierarchy\n        projectStartYear\n        projectStartMonth\n        projectStartDay\n        projectEndYear\n        projectEndMonth\n        projectEndDay\n        status\n        projectColor\n        isJiraProject\n        jiraSubtaskType\n        jiraCloudProject {\n          id\n        }\n        jiraCloudEpicIds\n        jiraServerProject {\n          id\n        }\n        gitlabProjectName\n        gitlabServerProjectName\n        projectGroupId\n        billable\n        taskLevels\n        companyProjectId\n        customProjectId\n        ...DeprecatedProjectIndicatorJS_project\n        isProgramRevenueLocked\n        programBudgetType\n        program {\n          name\n          prefix\n          budgetType\n          members {\n            edges {\n              node {\n                role\n                person {\n                  id\n                }\n                id\n              }\n            }\n          }\n          id\n        }\n        harvestProject {\n          id\n        }\n        manualProgressOnProjectEnabled\n        manualProgressOnPhasesEnabled\n        manualProgressOnTasksEnabled\n        vstsProject\n        vstsAccount\n        vstsTwoWaySync\n        sprintTimeBox\n        estimationUnit\n        remainingAutoCalculated\n        rateCard {\n          id\n          disabledRoles {\n            id\n          }\n        }\n        projectPersons(first: 10000) {\n          edges {\n            node {\n              id\n              person {\n                id\n                firstName\n                lastName\n                fullName\n                profilePictureId\n                profilePictureDefaultId\n                active\n                permissions\n                harvestUser\n              }\n              project {\n                id\n              }\n              role {\n                id\n                name\n              }\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        client {\n          id\n          name\n          logoId\n          logoDefaultId\n        }\n        phases(first: 10000) {\n          edges {\n            node {\n              id\n              name\n              startYear\n              startMonth\n              startDay\n              deadlineYear\n              deadlineMonth\n              deadlineDay\n            }\n          }\n        }\n        statusColumnsV2(first: 1000000) {\n          edges {\n            node {\n              id\n              name\n              category\n              order\n              jiraStatusId\n              adoState\n              projectGroupStatusColumnId\n              userActions {\n                canDelete\n                canDeleteWithTasks\n                canCreateTask\n                canRename\n                id\n              }\n            }\n          }\n        }\n        sprints(first: 10000) {\n          edges {\n            node {\n              id\n              name\n              startYear\n              startMonth\n              startDay\n              endYear\n              endMonth\n              endDay\n            }\n          }\n        }\n        completion\n        remaining\n        forecast\n      }\n      done\n      estimateForecastMinutes\n      progress\n    }\n    taskEdge {\n      node {\n        ...DraggableCard_task\n        id\n        userCanDeleteTask\n        userCantDeleteTaskReason\n        fullAccessToProject\n        approved\n        name\n        readOnly {\n          isReadOnly\n          id\n        }\n        coverFile {\n          id\n        }\n        parentTaskId\n        parentTask {\n          id\n          companyTaskId\n          name\n          parentTask {\n            id\n            companyTaskId\n            name\n          }\n        }\n        hasChildren\n        companyTaskId\n        blocked\n        bug\n        billable\n        highPriority\n        startYear\n        startMonth\n        startDay\n        description\n        jiraId\n        jiraKey\n        gitlabIid\n        vstsId\n        pipedriveId\n        isUnit4Task\n        estimateForecast\n        timeLeft\n        deadlineDay\n        deadlineMonth\n        deadlineYear\n        startFrom\n        deadlineFrom\n        gitlabServerIid\n        hasLockedTime\n        hasInvoicedTime\n        favoured\n        sageIntacctId\n        progressDetails {\n          progress\n          id\n        }\n        followers {\n          id\n          firstName\n          lastName\n          profilePictureId\n          profilePictureDefaultId\n        }\n        taskLabels {\n          label {\n            id\n            name\n            color\n          }\n          id\n        }\n        subTasks(first: 1000) {\n          edges {\n            node {\n              id\n              estimate\n              done\n              sortOrder\n              name\n              description\n              startDay\n              startMonth\n              startYear\n              endDay\n              endMonth\n              endYear\n              startFrom\n              endFrom\n              role {\n                id\n                name\n              }\n              person {\n                id\n                firstName\n                lastName\n                active\n                profilePictureId\n                profilePictureDefaultId\n              }\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        thisTaskDependsOn(first: 1000) {\n          edges {\n            node {\n              id\n              type\n              completed\n              taskDependsOnThis {\n                id\n                name\n                companyTaskId\n                startYear\n                startMonth\n                startDay\n                deadlineDay\n                deadlineMonth\n                deadlineYear\n                statusColumnV2 {\n                  id\n                  category\n                }\n              }\n              thisDependsOnTask {\n                id\n                name\n                companyTaskId\n                startYear\n                startMonth\n                startDay\n                deadlineDay\n                deadlineMonth\n                deadlineYear\n                statusColumnV2 {\n                  id\n                  category\n                }\n              }\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        dependsOnThisTask(first: 1000) {\n          edges {\n            node {\n              id\n              type\n              completed\n              taskDependsOnThis {\n                id\n                name\n                companyTaskId\n                startYear\n                startMonth\n                startDay\n                deadlineDay\n                deadlineMonth\n                deadlineYear\n                statusColumnV2 {\n                  id\n                  category\n                }\n              }\n              thisDependsOnTask {\n                id\n                name\n                companyTaskId\n                startYear\n                startMonth\n                startDay\n                deadlineDay\n                deadlineMonth\n                deadlineYear\n                statusColumnV2 {\n                  id\n                  category\n                }\n              }\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        repeatingTask {\n          id\n          repeatType\n          monday\n          tuesday\n          wednesday\n          thursday\n          friday\n          saturday\n          sunday\n          monthlyDay\n        }\n        statusColumnV2 {\n          id\n          name\n          category\n          projectGroupStatusColumnId\n        }\n        phase {\n          id\n          name\n          startYear\n          startMonth\n          startDay\n          deadlineDay\n          deadlineMonth\n          deadlineYear\n        }\n        sprint {\n          id\n          name\n          startYear\n          startMonth\n          startDay\n          endDay\n          endMonth\n          endYear\n        }\n        assignedPersons {\n          id\n          firstName\n          lastName\n          role {\n            id\n            name\n          }\n          profilePictureId\n          profilePictureDefaultId\n          email\n        }\n        timeRegistrations(first: 5000) {\n          edges {\n            node {\n              id\n              invoiced\n              xeroInvoiceId\n              minutesRegistered\n              lockedInPeriod\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        role {\n          id\n          name\n        }\n        googleDriveFiles(first: 10000) {\n          edges {\n            node {\n              id\n              name\n              link\n              thumb\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        files(first: 10000) {\n          edges {\n            node {\n              id\n              name\n              mimeType\n              key\n              size\n              yearCreated\n              monthCreated\n              dayCreated\n              hourCreated\n              minuteCreated\n              secondCreated\n              person {\n                id\n                fullName\n              }\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        commentCount\n        comments(first: 100000) {\n          edges {\n            node {\n              id\n              comment\n              year\n              month\n              day\n              hours\n              minutes\n              seconds\n              person {\n                id\n                firstName\n                lastName\n                fullName\n                profilePictureId\n                profilePictureDefaultId\n              }\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        createdAt\n        createdBy {\n          id\n          firstName\n          lastName\n        }\n        latestUiUpdateAt\n        latestUiUpdateBy {\n          id\n          firstName\n          lastName\n        }\n        owner {\n          id\n          firstName\n          lastName\n          fullName\n          profilePictureId\n          profilePictureDefaultId\n          role {\n            id\n            name\n          }\n        }\n        project {\n          id\n          name\n          useTaskOwner\n          useTaskFollowers\n          useTaskHierarchy\n          projectStartYear\n          projectStartMonth\n          projectStartDay\n          projectEndYear\n          projectEndMonth\n          projectEndDay\n          status\n          projectColor\n          isJiraProject\n          jiraSubtaskType\n          jiraCloudProject {\n            id\n          }\n          jiraCloudEpicIds\n          jiraServerProject {\n            id\n          }\n          gitlabProjectName\n          gitlabServerProjectName\n          projectGroupId\n          billable\n          taskLevels\n          companyProjectId\n          customProjectId\n          ...DeprecatedProjectIndicatorJS_project\n          isProgramRevenueLocked\n          programBudgetType\n          program {\n            name\n            prefix\n            budgetType\n            members {\n              edges {\n                node {\n                  role\n                  person {\n                    id\n                  }\n                  id\n                }\n              }\n            }\n            id\n          }\n          harvestProject {\n            id\n          }\n          manualProgressOnProjectEnabled\n          manualProgressOnPhasesEnabled\n          manualProgressOnTasksEnabled\n          vstsProject\n          vstsAccount\n          vstsTwoWaySync\n          sprintTimeBox\n          estimationUnit\n          remainingAutoCalculated\n          rateCard {\n            id\n            disabledRoles {\n              id\n            }\n          }\n          projectPersons(first: 10000) {\n            edges {\n              node {\n                id\n                person {\n                  id\n                  firstName\n                  lastName\n                  fullName\n                  profilePictureId\n                  profilePictureDefaultId\n                  active\n                  permissions\n                  harvestUser\n                }\n                project {\n                  id\n                }\n                role {\n                  id\n                  name\n                }\n                __typename\n              }\n              cursor\n            }\n            pageInfo {\n              endCursor\n              hasNextPage\n            }\n          }\n          client {\n            id\n            name\n            logoId\n            logoDefaultId\n          }\n          phases(first: 10000) {\n            edges {\n              node {\n                id\n                name\n                startYear\n                startMonth\n                startDay\n                deadlineYear\n                deadlineMonth\n                deadlineDay\n              }\n            }\n          }\n          statusColumnsV2(first: 1000000) {\n            edges {\n              node {\n                id\n                name\n                category\n                order\n                jiraStatusId\n                adoState\n                projectGroupStatusColumnId\n                userActions {\n                  canDelete\n                  canDeleteWithTasks\n                  canCreateTask\n                  canRename\n                  id\n                }\n              }\n            }\n          }\n          sprints(first: 10000) {\n            edges {\n              node {\n                id\n                name\n                startYear\n                startMonth\n                startDay\n                endYear\n                endMonth\n                endDay\n              }\n            }\n          }\n          completion\n          remaining\n          forecast\n        }\n        done\n        estimateForecastMinutes\n        progress\n      }\n    }\n  }\n}\n\nfragment DeprecatedProjectIndicatorJS_project on ProjectType {\n  name\n  companyProjectId\n  customProjectId\n  projectColor\n}\n\nfragment DraggableCard_task on Task {\n  id\n  billable\n  latestUiUpdateAt\n  description\n  timeLeft\n  progress\n  favouredSortOrder\n  estimateForecastMinutes\n  totalMinutesRegistered\n  companyTaskId\n  readOnly {\n    isReadOnly\n    id\n  }\n  userCanDeleteTask\n  userCantDeleteTaskReason\n  hasChildren\n  sageIntacctId\n  name\n  favoured\n  highPriority\n  bug\n  blocked\n  startDay\n  startMonth\n  startYear\n  deadlineDay\n  deadlineMonth\n  jiraId\n  vstsId\n  deadlineYear\n  subTaskCount\n  fileCount\n  commentCount\n  done\n  parentTaskId\n  hasInvoicedTime\n  role {\n    id\n    name\n  }\n  parentTask {\n    name\n    id\n  }\n  statusColumnV2 {\n    id\n    category\n    projectGroupStatusColumnId\n  }\n  taskLabels {\n    id\n    label {\n      id\n      name\n      color\n    }\n  }\n  coverFile {\n    id\n    name\n    key\n  }\n  project {\n    id\n    companyProjectId\n    projectColor\n    name\n    status\n    projectStartYear\n    projectStartMonth\n    projectStartDay\n    projectEndYear\n    projectEndMonth\n    projectEndDay\n    projectGroupId\n    unit4Project {\n      activitiesEnabled\n      id\n    }\n    harvestProject {\n      id\n    }\n    client {\n      name\n      logoId\n      logoDefaultId\n      id\n    }\n    isProgramRevenueLocked\n    programBudgetType\n    ...DeprecatedProjectIndicatorJS_project\n  }\n  thisTaskDependsOn(first: 1000) {\n    edges {\n      node {\n        id\n        type\n        thisDependsOnTask {\n          statusColumnV2 {\n            category\n            id\n          }\n          id\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  dependsOnThisTask(first: 1000) {\n    edges {\n      node {\n        id\n        type\n        taskDependsOnThis {\n          id\n          statusColumnV2 {\n            category\n            id\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  assignedPersons {\n    id\n    firstName\n    lastName\n    fullName\n    email\n    profilePictureId\n    profilePictureDefaultId\n    active\n    permissions\n    role {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4cf977e17fa36ba783c19f38014cb2b1";

export default node;
